module.exports = __webpack_public_path__ + "img/bx.adc1a780.png";